import { z } from 'zod';

export const BusinessUserDTO = z.object({
  user_id: z.number(),
  receive_leads: z.boolean(),
  receive_status: z.boolean(),
});

export type BusinessUser = z.TypeOf<typeof BusinessUserDTO>;

export const exampleBusinessUser: BusinessUser = {
  user_id: 1,
  receive_leads: true,
  receive_status: true,
};
